import React, { useCallback } from 'react'
import { useTranslation, constants } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import AciHighwayManifestKeys from '../../../constants/locale/key/AciHighwayManifest'
import AceHighwayManifestKeys from '../../../constants/locale/key/AceHighwayManifest'
import AciHighwayCargoKeys from '../../../constants/locale/key/AciHighwayCargo'
import AciHighwayResponseKeys from '../../../constants/locale/key/AciHighwayResponse'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

const ACIHighwayManifestTranslationText = () => {
    const { translate } = useTranslation([
        Namespace.ACI_HIGHWAY_MANIFEST,
        Namespace.ACE_HIGHWAY_MANIFEST
    ])

    let manifest = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TITLE)
    let carrierCode = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SCAC)
    let tripNum = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TRIP_NUM)
    let expArrivalDate = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EXP_ARRIVAL_DATE)
    let expArrivalDateOnly = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EXP_ARRIVAL_DATE_ONLY)
    let expArrivalTime = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EXP_ARRIVAL_TIME)
    let firstExpectedPort = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FIRST_EXPECTED_PORT)
    let templateFlag = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TEMPLATE_FLAG)
    let templateName = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TEMPLATE_NAME)
    let timeZone = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TIMEZONE)
    let messageFunction = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MESSAGE_FUNCTION)
    let amendmentCode = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.AMENDMENT_CODE)
    let trucktile = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TRUCKTITLE)
    let truckId = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TRUCK_ID)
    let conveyanceType = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CONVEYANCE_TYPE)
    let conveyanceNum = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CONVEYANCE_NUM)
    let licenseNum = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.LICENSE_NUM)
    let countryCode = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.COUNTRY_CODE)
    let state = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.STATE)
    let email = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EMAIL)
    let saveTruckFlag = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SAVE_TRUCKFLAG)
    let fetchTruck = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FETCH_TRUCK)
    let sealtitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_TITLE)
    let exceptionCargo = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EXCEPTION_CARGO)
    let sealNo1 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO1)
    let sealNo2 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO2)
    let sealNo3 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO3)
    let sealNo4 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO4)
    let sealNo5 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO5)
    let sealNo6 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO6)
    let sealNo7 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO7)
    let sealNo8 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO8)
    let sealNo9 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO9)
    let sealNo10 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO10)
    let sealNo11 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO11)
    let sealNo12 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO12)
    let sealNo13 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO13)
    let sealNo14 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO14)
    let sealNo15 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO15)
    let sealNo16 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO16)
    let sealNo17 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO17)
    let sealNo18 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO18)
    let sealNo19 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO19)
    let sealNo20 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO20)
    let iit = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.IIT)
    let lvs = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.LVS)
    let postal = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.POSTAL)
    let flyingTrucks = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FLYING_TRUCKS)
    let createButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CREATE_BUTTON)
    let saveButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SAVE_BUTTON)
    let saveAndContinueButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SAVE_AND_CONTINUE_BUTTON)
    let updateAndContinueButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.UPDATE_AND_CONTINUE_BUTTON)
    let updateButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.UPDATE_BUTTON)
    let discardButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.DISCARD_BUTTON)
    let deleteButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.DELETE_BUTTON)
    let createACEManifestButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CREATE_ACE_MANIFEST_BUTTON)
    let skipButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SKIP_BUTTON)
    let submitManifestButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SUBMIT_MANIFEST_BUTTON)
    let personDTO = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.TITLE)
    let crewId = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.CREW_ID)
    let role = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.ROLE)
    let fastCard = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.FAST_CARD)
    let fastCardNum = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.FAST_CARD_NUM)
    let firstName = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.FIRST_NAME)
    let middleName = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.MIDDLE_NAME)
    let lastName = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.LAST_NAME)
    let citizenShip = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.CITIZEN_SHIP)
    let dateOfBirth = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.DATE_OF_BIRTH)
    let personEmail = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.PERSON_EMAIL)
    let cellNum = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.CELL_NUM)
    let personDocumentDTO = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDocumentDTO.TITLE)
    // let _personDTOId = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDocumentDTO.PERSON_DTO)
    let documentType = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDocumentDTO.DOCUMENT_TYPE)
    let issuingCountry = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDocumentDTO.ISSUING_COUNTRY)
    let documentNumber = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDocumentDTO.DOCUMENT_NUMBER)
    let expiryDate = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDocumentDTO.EXPIRY_DATE)
    let trailerDTO = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.TITLE)
    let equipmentId = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.EQUIPMENT_ID)
    let cargoLoadedIn = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.CARGO_LOADED_IN)
    let equipmentNumber = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.EQUIPMENT_NUMBER)
    let licensePlateNum = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.LICENSE_PLATE_NUM)
    let licensePlateNo = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.LICENSE_PLATE_NO)
    let country = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.COUNTRY)
    let stateCode = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.STATE_CODE)
    let container1 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.CONTAINER1)
    let container2 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.CONTAINER2)
    let container3 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.CONTAINER3)
    let container4 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.CONTAINER4)
    let container5 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.CONTAINER5)
    let sealNoHideText = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO_HIDE_TEXT)
    let sealNoShowText = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO_SHOW_TEXT)
    let sealNoFooterText = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_NO_FOOTER_TEXT)
    let exemptionCargoHideText = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EXEMPTION_CARGO_HIDE_TEXT)
    let exemptionCargoShowText = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EXEMPTION_CARGO_SHOW_TEXT)
    let exemptionCargoFooterText = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EXEMPTION_CARGO_FOOTER_TEXT)
    let tripSectionHelper = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TRIP_SECTION_HELPER)
    let truckTrailerSectionHelper = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TRUCK_TRAILER_SECTION_HELPER)
    let crewSectionHelper = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CREW_SECTION_HELPER)
    let useTemplate = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.USE_TEMPLATE)
    let truckConveyance = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TRUCK_CONVEYANCE)
    let mandatoryFields = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MANDATORY_FIELDS)
    let licensePlate = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.LICENSE_PLATE)
    let driverCrewPassenger = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.DRIVER_CREW_PASSENGER)
    let trailerDTOTitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.TITLE)
    let action = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.ACTION)
    let noRecordsToDisplay = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.NO_RECORD_TO_DISPLAY)
    let addEquipment = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.ADD_EQUIPMENT)
    let activityLogTitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ACTIVITY_LOGS)
    let createdDate = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CREATED_DATE_TIME)
    let loginUserId = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.LOGIN_USER_ID)
    let functionCode = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FUNCTION_CODE)
    let auditDescription = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.AUDIT_DESC)
    let aceId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ACE_ID)
    let conveyanceId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CONVEYANCE_ID)
    let conveyanceNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CONVEYANCE_NO)
    let countryRegistration = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.COUNTRY_REGISTRATION)
    let provinceStateRegionRegistration = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PROVINCE_STATE_REGION_REGISTRATION)
    let conveyanceTemplateTitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CONVEYANCE_TEMPLATE_TITLE)
    let submitSuccessMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SUBMIT_SUCCESS_MSG)
    let sendButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEND_BUTTON)
    let emailCoverSheet = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EMAIL_COVERSHEET)
    let emailCoversheetSuccess = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EMAIL_COVERSHEET_SUCCESS)
    let emailCoversheetError = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EMAIL_COVERSHEET_ERROR)
    let emailSubject = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EMAIL_SUBJECT)
    let emailMessage = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EMAIL_MESSAGE)
    let emailValid = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.EMAIL_VALID)
    let requiredMessage = translate(Namespace.COMMON_VALIDATION_MSG, CommonValidationMessageKeys.REQUIRED)
    let faxTitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FAX_COVERSHEET)
    let faxCoversheetSuccess = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FAX_COVERSHEET_SUCCESS)
    let faxCoversheetError = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FAX_COVERSHEET_ERROR)
    let fax = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FAX)
    let faxHelpText = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FAX_HELP_TEXT)
    let faxRemark = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FAX_REMARK)
    let note = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.NOTE)
    let faxValid = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.FAX_VALID)
    let numOnlyNoSpace = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.NUM_ONLY_NO_SPACE)
    let minLength11 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.MIN_LENGTH_11)
    let dateTypeErrorMessage = translate(Namespace.COMMON_VALIDATION_MSG, CommonValidationMessageKeys.DATE_TYPE_ERROR )
    let carrierCodeLength = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.CARRIER_CODE_LENGTH)
    let carrierCodeRegX = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.CARRIER_CODE_REGX)
    let tripNumLength = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.TRIP_NUM_LENGTH)
    let tripNumPrefix = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.TRIP_NUM_PREFIX)
    let expArrivalDateValidation = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.EXP_ARRIVAL_DATE)
    let alphaNumericRegx = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.ALPHA_NUMERIC_REGX)
    let expArrivalDateRegx = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.EXP_ARRIVAL_DATE_REGX)
    let alphaNumericSpaceRegx = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.ALPHA_NUMERIC_SPACE_REGX)
    let numericRegx = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.NUMERIC_REGX)
    let emailMaxLength = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.EMAIL_MAX_LENGTH)
    let msgfunForAC = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.MSGFUN_FOR_AC)
    let msgfunForDR = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.MSGFUN_FOR_DR)
    let msgfunForCL = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.MSGFUN_FOR_CL)
    let msgfunForMR = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.MSGFUN_FOR_MR)
    let msgfunForRJ = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.MSGFUN_FOR_RJ)
    let msgfunForCR = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.MSGFUN_FOR_CR)
    let msgfunForNewRec = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.MSGFUN_FOR_NEW_REC)
    let alphaNumericWithMoreSplChars = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.ALPHA_NUMERIC_WITH_MORE_SPLCHARS)
    let nonFastcardUser = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.NON_FAST_CARD_USER)
    let maxLength15 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.MAX_LENGTH_15)
    let maxLength25 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.MAX_LENGTH_25)
    let maxLength255 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.MAX_LENGTH_255)
    let enterValidInput = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.ENTER_VALID_INPUT)
    let expiryDateValidation = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.EXPIRY_DATE)
    let recordAddSuccess = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.RECORD_ADD_SUCCESS)
    let addDiscardConfirmMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ADD_DISCARD_CONFIRM_MSG)
    let addDiscardProceedMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ADD_DISCARD_PROCEED_MSG)
    let addDiscardCancelMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ADD_DISCARD_CANCEL_MSG)
    let discardTitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.DISCARD_TITLE)
    let portCodeChangedConfirmMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PORT_CODE_CHANGED_CONFIRM_MSG)
    let ccnHousebillOverLimitMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CCN_HOUSEBILL_OVERLIMIT_MSG)
    let emptyTripConfirmMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EMPTY_TRIP_CONFIRM_MSG)
    let withFastCard = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.WITH_FAST_CARD)
    let withTravelDocument = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.WITH_TRAVEL_DOCUMENT)
    let noteClearSuccessMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.NOTE_CLEAR_SUCCESS_MSG)
    let noteUpdateSuccessMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.NOTE_UPDATE_SUCCESS_MSG)
    let noteSaveErrorMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.NOTE_SAVE_ERROR_MSG)
    let noteLogSaveErrorMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.NOTE_LOG_SAVE_ERROR_MSG)
    let noteClearErrorMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.NOTE_CLEAR_ERROR_MSG)
    let noteContent = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.NOTE_CONTENT)
    let max300Char = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MAX_300_CHAR)
    let noteForManifest = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.NOTE_FOR_MANIFEST)
    let invalidCharFound = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.INVALID_CHAR_FOUND)
    let reminderNote = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.REMINDER_NOTE)
    let resetNote = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.RESET_NOTE)
    let createdDateEst = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CREATED_DATE_EST)
    let username = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.USERNAME)
    let noteLabel = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.NOTE_LABEL)
    let personDocumentTitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDocumentDTO.TITLE)
    let addNewLabel = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ADD_NEW_LABEL)
    let cloneLabel = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CLONE_LABEL)
    let deleteLabel = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.DELETE_LABEL)
    let fetchCrew = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.FETCH_CREW)
    let saveCrewFlag = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PersonDTO.SAVE_CREW_FLAG)
    let aplhaNumericWithSplChars = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.Validations.ALPHA_NUMERIC_WITH_SPLCHARS)
    let name = translate(Namespace.ACIHWY_MANIFEST,AciHighwayManifestKeys.StatusNotification.NAME)
    let snType = translate(Namespace.ACIHWY_MANIFEST,AciHighwayManifestKeys.StatusNotification.SN_TYPE)
    let shipmentControlNum = translate(Namespace.ACIHWY_MANIFEST,AciHighwayManifestKeys.StatusNotification.SHIPMENT_CONTROL_NUM)
    let mobileNum = translate(Namespace.ACIHWY_MANIFEST,AciHighwayManifestKeys.StatusNotification.MOBILE_NUM)
    let faxNum = translate(Namespace.ACIHWY_MANIFEST,AciHighwayManifestKeys.StatusNotification.FAX_NUM)
    let statusNotificationTitle = translate(Namespace.ACE_HIGHWAY_MANIFEST, AciHighwayManifestKeys.StatusNotification.TITLE)
    let deleteItemConfirmMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AciHighwayManifestKeys.DELETE_ITEM_CONFIRM_MSG)
    let okDeleteButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.OK_DELETE_BUTTON)
    let cancelDeleteButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CANCEL_DELETE_BUTTON)
    let scac = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SCAC)
    let driver = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.DRIVER)
    let truck = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TRUCKTITLE)
    let trailer = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.TITLE)
    let cargoCount = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CARGO_COUNT)
    let creationdatetime = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CREATIONDATETIME)
    let submittedDate = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SUBMITTED_DATE)
    let status = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.STATUS)
    let reviewStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.REVIEW_STATUS)
    let editSentRecords = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EDIT_SENT_RECORDS)
    let editButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EDIT_BUTTON)
    let cloneButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CLONE_BUTTON)
    let printCoverSheet = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PRINT_COVERSHEET)
    let d4 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.D4)
    let cancelButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CANCEL_BUTTON)
    let cancelMultipleRecords = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CANCEL_MULTIPLE_RECORDS)
    let noteFlag = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.NOTE_FLAG)
    let faxCoverSheet = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FAX_COVERSHEET)
    let ccn = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CCN)
    let totalNoOfCargo = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TOTAL_NO_OF_CARGO)
    let cargo = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CARGO)
    let quickGlanceTitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.QUICK_GLANCE_TITLE)
    let okayButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.OKAY_BUTTON)
    let errorOccured = translate(Namespace.COMMON_VALIDATION_MESSAGE, CommonValidationMessageKeys.ERROR_CONTACT_CUSTOMER_SERVICE)
    let deleteWarningMessage = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.DELETE_WARNING_MESSAGE)
    let viewResponse = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.VIEW_RESPONSE)
    let cargoStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CARGO_STATUS)
    let portMismatch = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PORT_MISMATCH)
    let quickGlanceAtCargo = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.QUICK_GLANCE_AT_CARGO)
    let followUpStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.FOLLOW_UP_STATUS)
    let lastModifiedDate = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.LAST_MODIFIED_DATE)
    let draftStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.DRAFT_STATUS)
    let acceptedStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ACCEPTED_STATUS)
    let sentStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SENT_STATUS)
    let rejectedStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.REJECTED_STATUS)
    let statusNotificationStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.STATUS_NOTIFICATION_STATUS)
    let cancellationAcceptedStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CANCELLATION_ACCEPTED_STATUS)
    let cancellationRejectedStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CANCELLATION_REJECTED_STATUS)
    let modificationRejectedStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MODIFICATION_REJECTED_STATUS)
    let truckArrivedStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TRUCK_ARRIVED_STATUS)
    let goodsReleasedStatus = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.GOODS_RELEASED_STATUS)
    let pendingReview = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PENDING_REVIEW)
    let reviewInProgress = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.REVIEW_IN_PROGRESS)
    let reviewed = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.REVIEWED)
    let deleteSucceeded = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.DELETE_SUCCEEDED)
    let manifestCancelledMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MANIFEST_CANCELLED_MSG)
    let manifestCancelSentMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MANIFEST_CANCEL_SENT_MSG)
    let manifestDeleteInProgressMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MANIFEST_DELETE_IN_PROGRESS_MSG)
    let massDeleteSucceedMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MANIFEST_DELETE_SUCCEED_MSG)
    let massDeleteErrorMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MANIFEST_DELETE_ERROR_MSG)
    let createManifest = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CREATE_MANIFEST)
    let manifestTemplate = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MANIFEST_TEMPLATE)
    let exportMax100 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EXPORT_MAX_100)
    let exportManifestInBackground = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EXPORT_MANIFEST_IN_BACKGROUND)
    let onlyDraftCanBeDeleted = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ONLY_DRAFT_CAN_BE_DELETED)
    let responseLogTitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.RESPONSE_LOG_TITLE)
    let containerTitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.CONATINER_TITLE)
    let sealTitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEAL_TITLE)
    let exceptioncargoTitle = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.EXCEPTION_CARGO)
    let saveTrailerFlag = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.SAVE_TRAILER_FLAG)
    let fetchEquipment = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.FETCH_EQUIPMENT)
    let contSealExCargoFlag = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.TrailerDTO.CONT_SEAL_EXCARGOFLAG)
    let containerInfoHideText = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CANTAINER_HIDE_TEXT)
    let containerInfoShowText = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CANTAINER_SHOW_TEXT)
    let containerInfoFooterText = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CANTAINER_FOOTER_TEXT)
    let attachCargoSuccessMsg = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ATTACH_CARGO_SUCESS_MSG)
    let attach = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ATTACH)
    let attachSentRecord = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ATTACH_SENT)
    let attachCargoTitle = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ATTACH_CARGO_TITLE)
    let cargoType = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_TYPE)
    let acquittalNo = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ACQUITTAL_NO)
    let createdDateTime = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CREATIONDATETIME)
    let arrivalDateAndTime = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ARRIVAL_DATE_AND_TIME)
    let arrivalDateAndTimeZone = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ARRIVAL_DATE_AND_TIME_ZONE)
    let tripNo = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.TRIP_NO)
    let submitButton = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SUBMIT_BUTTON)
    let detachSuccessMsg = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DETACH_SUCCESS_MSG)
    let editSentRecord = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.EDIT_SENT_RECORDS)
    let detachSentRecord = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DETACH_SENT_REC)
    let submitErrorMessage = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SUBMIT_ERROR_MSG)
    let submitSentRecord = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SUBMIT_SENT_RECORD)
    let msgFunctionAdd = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MESSAGE_FUNCTION_ADD)
    let msgFunctionModify = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MESSAGE_FUNCTION_MODIFY)
    let msgFunctionDelete = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MESSAGE_FUNCTION_DELETE) 
    let msgFunctionCorrected = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.MESSAGE_FUNCTION_CORRECTED)
    let printA8A = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PRINT_A8A)
    let printA49 = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PRINT_A49)
    let printMultipleRecords = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.PRINT_MULTIPLE_RECORDS)
    let shipperName = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SHIPPER_NAME)
    let consigneeName = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CONSIGNEE_NAME)
    let customsBroker = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CUSTOMS_BROKER)
    let entryNo = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ENTRY_NO)
    let attachCargoSectionHelper = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ATTACH_CARGO_SECTION_HELPER)
    let other = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.OTHER)
    let responseMsg = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.RESPONSE_MSG)
    let cargoCreateSuccess = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_CREATE_SUCCESS)
    let cargoUpdated = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_UPDATED)
    let cargoDeleteSucceeded = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_DELETE_SUCCEEDED)
    let cargoMassDeleteSucceeded = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_MASS_DELETE_SUCCEEDED)
    let cargoMassDeleteError = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_MASS_DELETE_ERROR)
    let fetchAmendmentCodeError = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.FETCH_AMENDMENT_CODE_ERROR)
    let a8aPrintInBg = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.A8A_PRINT_IN_BG)
    let printLimit100 = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.PRINT_LIMIT_100)
    let bulkPrintingA8A = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.BULK_PRINTING_A8A)
    let cargoDeleteInProgress = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CARGO_DELETE_IN_PROGRESS)
    let noFileAttachError = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.NO_FILE_ATTACH_ERROR)
    let fileUploadSuccess = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.FILE_UPLOAD_SUCCESS)
    let fileUploadError = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.FILE_UPLOAD_ERROR)
    let uploadCargoTitle = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.UPLOAD_CARGO_TITLE)
    let removeButton = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.REMOVE_BUTTON)
    let downloadCSVTemplateButton = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DOWNLOAD_CSV_TEMPLATE_BUTTON)
    let backButton = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.BACK_BUTTON)
    let submitToCustomButton = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SUBMIT_TO_CUSTOM_BUTTON)
    let setResponseMsgTitle = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SET_RESPONSE_MSG_TITLE)
    let submissionCargoStatus = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SUBMISSION_CARGO_STATUS)
    let submitForLabel = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SUBMIT_FOR_LABEL)
    let additionalCargo = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ADDITIONAL_CARGO)
    let customsBrokerName = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CUSTOMS_BROKER_NAME)
    let customsBrokerContact = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CUSTOMS_BROKER_CONTACT)
    let historyTitle = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.HISTORY_TITLE)
    let accountTitle = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ACCOUNT_TITLE)
    let accountNameAndOr = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ACCOUNT_NAME_AND_OR)
    let manifestResponseTitle = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.MANIFEST_RESPONSE)
    let cargoResponseTitle = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.CARGO_RESPONSE)
    let searchInYourEntry = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEARCH_IN_YOUR_ENTRY)
    let crewTemplate = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CREW_TEMPLATE)
    let searchForAnyKeyword = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SEARCH_FOR_ANY_KEYWORD)
    let noOfItemLabel = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.NO_OF_ITEM_LABEL)
    let itemPerPageLabel = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ITEM_PER_PAGE_LABEL)
    let submitAllCargo = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.SUBMIT_ALL_CARGO)
    let uploadNewCargo = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.UPLOAD_NEW_CARGO)
    let createNewCargo = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CREATE_NEW_CARGO)
    let attachCargo = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.ATTACH_CARGO)
    let addSNButton = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ADD_SN_BUTTON)
    let createTripStep = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.CREATE_TRIP_STEP)
    let addCargosStep = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ADD_CARGOS_STEP)
    let setStatusNotificationStep = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SET_STATUS_NOTIFICATION_STEP)
    let viewLogsAndHistoryStep = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.VIEW_LOGS_AND_HISTORY_STEP)
    let addSNLabel = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ADD_SN_LABEL)
    let orCloneThePrevOne = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.OR_CLONE_THE_PREV_ONE)
    let snUpdatedMsg = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.SN_UPDATED_MSG)
    let optional = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.OPTIONAL)
    let goToSubmit = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.GO_TO_SUBMIT)
    let id = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.ID)
    let insertAndPopulate = translate(Namespace.ACIHWY_MANIFEST, AciHighwayManifestKeys.INSERT_AND_POPULATE)
    let title = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.CARGO_RESPONSE)
    let responseId = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.RESPONSE_ID)
    let responseDate = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.RESPONSE_DATE)
    let responseCode = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.RESPONSE_CODE)
    let responseText = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.RESPONSE_TEXT)
    let cbsaResponseDate = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.CBSA_RESPONSE_DATE)
    let submissionType = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.SUBMISSION_TYPE)
    let remarks = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.REMARKS)
    let errorCode = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.ERRORCODE)
    let submitId = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.SUBMIT_ID)
    let methodOfSubmission = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.METHOD)
    let responseDispositionCode = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.RESPONSE_DISPOSITION_CODE)
    let entryType = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayResponseKeys.ENTRY_TYPE)
    let rowPerPageLabel = translate(Namespace.ACI_HIGHWAY_RESPONSE, AciHighwayManifestKeys.ROW_PER_PAGE)

    return {
        manifest,
        carrierCode,
        tripNum,
        messageFunction,
        amendmentCode,
        expArrivalDate,
        expArrivalDateOnly,
        expArrivalTime,
        templateFlag,
        templateName,
        timeZone,
        firstExpectedPort,
        personDTO,
        fetchTruck,
        crewId,
        role,
        fastCard,
        fastCardNum,
        firstName,
        middleName,
        lastName,
        citizenShip,
        dateOfBirth,
        personEmail,
        cellNum,
        personDocumentDTO,
        //   _personDTOId,
        documentType,
        issuingCountry,
        documentNumber,
        expiryDate,
        truckId,
        exceptionCargo,
        sealtitle,
        trucktile,
        conveyanceType,
        conveyanceNum,
        licenseNum,
        countryCode,
        state,
        email,
        saveTruckFlag,
        sealNo1,
        sealNo2,
        sealNo3,
        sealNo4,
        sealNo5,
        sealNo6,
        sealNo7,
        sealNo8,
        sealNo9,
        sealNo10,
        sealNo11,
        sealNo12,
        sealNo13,
        sealNo14,
        sealNo15,
        sealNo16,
        sealNo17,
        sealNo18,
        sealNo19,
        sealNo20,
        iit,
        lvs,
        postal,
        flyingTrucks,
        trailerDTO,
        equipmentId,
        cargoLoadedIn,
        equipmentNumber,
        licensePlateNum,
        licensePlateNo,
        country,
        stateCode,
        container1,
        container2,
        container3,
        container4,
        container5,
        createButton,
        saveButton,
        saveAndContinueButton,
        updateAndContinueButton,
        updateButton,
        discardButton,
        deleteButton,
        createACEManifestButton,
        skipButton,
        submitManifestButton,
        sealNoHideText,
        sealNoShowText,
        sealNoFooterText,
        exemptionCargoHideText,
        exemptionCargoShowText,
        exemptionCargoFooterText,
        tripSectionHelper,
        truckTrailerSectionHelper,
        crewSectionHelper,
        useTemplate,
        truckConveyance,
        mandatoryFields,
        licensePlate,
        driverCrewPassenger,
        trailerDTOTitle,    
        action,
        noRecordsToDisplay,
        addEquipment,
        activityLogTitle,
        createdDate,
        loginUserId,
        functionCode,
        auditDescription,    
        aceId,
        conveyanceId,
        conveyanceNo,
        countryRegistration,
        provinceStateRegionRegistration,
        conveyanceTemplateTitle,
        submitSuccessMsg,
        sendButton,
        emailCoverSheet,
        emailCoversheetSuccess,
        emailCoversheetError,
        emailSubject,
        emailMessage,  
        emailValid,    
        requiredMessage,  
        faxTitle,
        faxCoversheetSuccess,
        faxCoversheetError,
        fax,
        faxHelpText,
        faxRemark,
        note,
        faxValid,
        numOnlyNoSpace,
        minLength11,
        dateTypeErrorMessage,
        carrierCodeLength,
        carrierCodeRegX,
        tripNumLength,
        tripNumPrefix,
        expArrivalDateValidation,
        alphaNumericRegx,
        expArrivalDateRegx,
        alphaNumericSpaceRegx,
        numericRegx,
        emailMaxLength,
        msgfunForAC,
        msgfunForDR,
        msgfunForCL,
        msgfunForMR,
        msgfunForRJ,
        msgfunForCR,
        msgfunForNewRec,
        alphaNumericWithMoreSplChars,
        nonFastcardUser,
        maxLength15,
        maxLength25,
        maxLength255,
        enterValidInput,
        expiryDateValidation,
        recordAddSuccess,
        addDiscardConfirmMsg,
        addDiscardProceedMsg,
        addDiscardCancelMsg,
        discardTitle,
        portCodeChangedConfirmMsg,
        ccnHousebillOverLimitMsg,
        emptyTripConfirmMsg,
        withFastCard,
        withTravelDocument,
        noteClearSuccessMsg,
        noteUpdateSuccessMsg,
        noteSaveErrorMsg,
        noteLogSaveErrorMsg,
        noteClearErrorMsg,
        noteContent,
        max300Char,
        noteForManifest,
        invalidCharFound,
        reminderNote,
        resetNote,
        createdDateEst,
        username,
        noteLabel,
        personDocumentTitle,
        addNewLabel,
        cloneLabel,
        deleteLabel,
        fetchCrew,
        saveCrewFlag,
        aplhaNumericWithSplChars,
        name,
        snType,
        shipmentControlNum,
        mobileNum,
        faxNum,
        statusNotificationTitle,
        deleteItemConfirmMsg,
        okDeleteButton,
        cancelDeleteButton,
        scac,
        driver,
        truck,
        trailer,
        cargoCount,
        creationdatetime,
        submittedDate,
        status,
        reviewStatus,
        editSentRecords,
        editButton,
        cloneButton,
        printCoverSheet,
        d4,
        cancelButton,
        cancelMultipleRecords,
        noteFlag,
        faxCoverSheet,
        ccn,
        totalNoOfCargo,
        cargo,
        quickGlanceTitle,
        okayButton,
        errorOccured,
        deleteWarningMessage,        
        viewResponse,
        cargoStatus,
        portMismatch,
        quickGlanceAtCargo,
        followUpStatus,
        lastModifiedDate,
        draftStatus,
        acceptedStatus,
        sentStatus,
        rejectedStatus,        
        statusNotificationStatus,
        cancellationAcceptedStatus,
        cancellationRejectedStatus,
        modificationRejectedStatus,
        truckArrivedStatus,
        goodsReleasedStatus,    
        pendingReview,
        reviewInProgress,
        reviewed,     
        deleteSucceeded,       
        manifestCancelledMsg,
        manifestCancelSentMsg,
        manifestDeleteInProgressMsg,
        massDeleteSucceedMsg,
        massDeleteErrorMsg,
        createManifest,
        manifestTemplate,
        exportMax100,
        exportManifestInBackground,
        onlyDraftCanBeDeleted,
        responseLogTitle,
        containerTitle,
        sealTitle,
        exceptioncargoTitle,
        saveTrailerFlag,
        fetchEquipment,
        contSealExCargoFlag,
        containerInfoHideText,
        containerInfoShowText,
        containerInfoFooterText,  
        attachCargoSuccessMsg,
        attach,
        attachSentRecord,   
        attachCargoTitle,  
        cargoType,
        acquittalNo,
        createdDateTime,
        arrivalDateAndTime,
        arrivalDateAndTimeZone,
        tripNo,
        submitButton,
        detachSuccessMsg,
        editSentRecord,
        detachSentRecord,
        submitErrorMessage,
        submitSentRecord,
        msgFunctionAdd,
        msgFunctionModify,
        msgFunctionDelete,
        msgFunctionCorrected,
        printA8A,
        printA49,
        printMultipleRecords,
        shipperName,
        consigneeName,
        customsBroker,
        entryNo,
        attachCargoSectionHelper,                 
        other,
        responseMsg,
        cargoCreateSuccess,
        cargoUpdated,
        cargoDeleteSucceeded,
        cargoMassDeleteSucceeded,
        cargoMassDeleteError,
        fetchAmendmentCodeError,
        a8aPrintInBg,
        printLimit100,
        bulkPrintingA8A,
        cargoDeleteInProgress,
        noFileAttachError,
        fileUploadSuccess,
        fileUploadError,
        uploadCargoTitle,
        removeButton,
        downloadCSVTemplateButton,
        backButton,
        submitToCustomButton,
        setResponseMsgTitle,
        submissionCargoStatus,
        submitForLabel,
        additionalCargo,
        customsBrokerName,
        customsBrokerContact,         
        historyTitle,
        accountTitle,
        accountNameAndOr,
        manifestResponseTitle,
        cargoResponseTitle,
        searchInYourEntry,
        crewTemplate,
        searchForAnyKeyword,
        noOfItemLabel,
        itemPerPageLabel,
        submitAllCargo,
        uploadNewCargo,
        createNewCargo,
        attachCargo,      
        addSNButton,  
        createTripStep,
        addCargosStep,
        setStatusNotificationStep,
        viewLogsAndHistoryStep,     
        addSNLabel,   
        orCloneThePrevOne,
        snUpdatedMsg,
        optional,
        goToSubmit,
        id,
        insertAndPopulate,
        cargoResponseTitle,
        responseId,
        responseDate,
        responseCode,
        responseText,
        cbsaResponseDate,
        submissionType,
        remarks,
        errorCode,
        submitId,
        methodOfSubmission,    
        responseDispositionCode,
        entryType,    
        rowPerPageLabel
    }
}

export default ACIHighwayManifestTranslationText